import { ProcesarDatosApi } from "../api/ApiFetch";

// ⬅️ controla la ruta base real del controller
const controladorFormulario = "FormularioPre";

// Normalizador para indicador/mensaje/id
const normalizarRespuesta = (res) => {
    let indicador = res?.indicador ?? res?.codigo ?? 0;
    let mensaje = res?.mensaje ?? res?.Mensaje ?? "";
    let idGenerado = 0;

    // A) "OK|123"
    if (typeof mensaje === "string" && mensaje.includes("|")) {
        const [m, idStr] = mensaje.split("|");
        mensaje = m;
        const id = parseInt(idStr, 10);
        if (!Number.isNaN(id)) idGenerado = id;
    }

    // B) "123" o 123 (tu SP hace SET @MENSAJE = @IdGenerado)
    if (!idGenerado) {
        const posible = typeof mensaje === "number" ? mensaje : parseInt(mensaje, 10);
        if (!Number.isNaN(posible)) idGenerado = posible;
    }

    // C) Campos alternos
    if (!idGenerado) idGenerado = res?.idGenerado ?? res?.IdGenerado ?? res?.valor ?? 0;

    return { indicador, mensaje, idGenerado };
};

export const ObtenerFormularios = async () => {
    const url = `${controladorFormulario}/ObtenerFormularios`;
    return await ProcesarDatosApi("GET", url);
};

export const ObtenerFormularioPorId = async (idFormulario) => {
    const url = `${controladorFormulario}/ObtenerFormularioPorId/${idFormulario}`;
    return await ProcesarDatosApi("GET", url);
};

export const AgregarFormulario = async (formulario) => {
    const url = `${controladorFormulario}/AgregarFormulario`;
    const payload = {
        Nombre: formulario?.Nombre ?? "",
        Descripcion: formulario?.Descripcion ?? "",
        Activo: formulario?.Activo ?? true,
        Preguntas: formulario?.Preguntas ?? [],
    };
    const res = await ProcesarDatosApi("POST", url, payload);
    return normalizarRespuesta(res);
};

export const EditarFormulario = async (formulario) => {
    const url = `${controladorFormulario}/EditarFormulario`;
    return await ProcesarDatosApi("PUT", url, formulario);
};

export const CambiarEstadoFormulario = async (idFormulario, activo) => {
    const url = `${controladorFormulario}/CambiarEstadoFormulario/${idFormulario}/${activo}`;
    return await ProcesarDatosApi("PUT", url);
};

export const EliminarFormulario = async (idFormulario) => {
    const url = `${controladorFormulario}/EliminarFormulario/${idFormulario}`;
    return await ProcesarDatosApi("DELETE", url);
};